/**
 *
 * Asynchronously loads the component for ButterflyIcon
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ButterflyIcon = lazyLoad(
  () => import('./index'),
  module => module.ButterflyIcon,
);
